<template>
  <BaseListMenu
    :id="id"
    :item="item"
    :event-bus="eventBus"
    :mobile="mobile"
    :custom="menu"
  />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
import BaseListMenu from "components/partials/Courses/ListMenu";

export default {
  mixins: [ContextMenuMixin],

  components: { BaseListMenu },

  props: {
    mobile: { type: Boolean, default: false },
  },

  computed: {
    routeParam() {
      return { course: this.item.id };
    },

    menu() {
      let menu = [
        {
          label: "Edit",
          action: () => {
            this.goToRoute("admin.courses.edit", this.routeParam);
          },
        },
        {
          label: "Clone",
          action: () => {
            this.doAction("clone");
          },
        },
      ];

      if (!!this.item.can_delete) {
        menu.push({
          label: "Remove",
          action: () => {
            this.doAction("remove");
          },
        });
      }

      if (!!this.item.is_active) {
        menu.push({
          label: "De-activate",
          action: () => {
            this.doAction("deactivate");
          },
        });
      } else {
        menu.push({
          label: "Activate",
          action: () => {
            this.doAction("activate");
          },
        });
      }

      if (!!this.item.is_online) {
        menu.push({
          label: "Enrollments",
          action: () => {
            this.goToRoute("admin.courses.enrollments.index", this.routeParam);
          },
        });
      }

      if (!!this.item.surveys_submitted) {
        menu.push({
          label: "View Survey Responses",
          action: () => {
            this.goToRoute("admin.courses.surveys.submissions.index", this.routeParam);
          },
        });
//        if (!!this.item.is_online) {
//           menu.push({
//             label: "Export Survey Summary",
//             action: () => {
//               this.goToRoute("surveys.course.summary", this.routeParam);
//             },
//           });
//        }
      }

      return menu;
    },
  },
};
</script>
